// La fila del cierre se identifica por lo que es —tipo, producto y condición— y
// no por el id de su registro, que solo existe cuando ya se le anotó algo. El
// tipo es la tabla en la que está la fila: "pacas" o "sobrante"

export const claveDeFila = (tipo, fila) => ({
    tipo,
    producto_id: fila.producto_id,
    es_conforme_bodega: fila.es_conforme_bodega,
});

export const esMismaFila = (fila, otra) =>
    fila.producto_id === otra.producto_id &&
    fila.es_conforme_bodega === otra.es_conforme_bodega;

export const rutaReajusteFila = (tipo, fila) =>
    "/produccion-bodega/inventario/reajuste/" +
    `${tipo}/${fila.producto_id}/${fila.es_conforme_bodega}`;

// Pacas por pallet de solo lectura. La de un cierre cerrado es su foto; la del
// cierre en proceso va a la fecha de corte que se está revisando, en
// milisegundos para que la ruta no lleve caracteres especiales
export const rutaPacasCierreCerrado = (cierreId, fila) =>
    `/produccion-bodega/inventario/cierre/${cierreId}/pacas/` +
    `${fila.producto_id}/${fila.es_conforme_bodega}`;

export const rutaPacasAlCorte = (fechaCorte, fila) =>
    "/produccion-bodega/inventario/pacas-al-corte/" +
    `${fila.producto_id}/${fila.es_conforme_bodega}/` +
    `${new Date(fechaCorte).getTime()}`;
